import { Service, serviceTypes } from '../types/ServiceTypes';

export const getServiceFromName = (serviceName: string): Service | undefined => {
  return serviceTypes.find((service) => service.name === serviceName);
};
